import React from 'react';

function NewSurveyButton(props) {
    return (
        <a className="surveys__menu__addnew" href="javascript:void(0)" onClick={props.toggleShowModal}>
            <img src="assets/img/surveys/add-new.png" alt=""/>
            <span>Create new survey</span>
        </a>
    );
}

export default NewSurveyButton;